import { useLocation } from "react-router";

declare global {
  export interface Window {
    OAuthAPI?: any;
  }
}

export function forwardMode(pathString: string, otherParams: Record<any, any> = {}) {
  if (typeof location === "undefined") {
    return;
  }

  const currentParams = new URLSearchParams(location.search);
  const mode = currentParams.get("mode");
  const newParams = new URLSearchParams(mode ? { ...otherParams, mode } : otherParams);
  return {
    pathname: pathString,
    search: newParams.toString(),
  };
}

export const useDetectApp = () => {
  const location = useLocation<any>();
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get("mode") === "app" || location.state?.mode === "app";
};

export function appHandleToken(token: string) {
  if (window.OAuthAPI) {
    window.OAuthAPI.sendToken(token);
  } else {
    const appURL = `ugg-app://auth/web/${encodeURIComponent(token)}`;
    window.location.href = appURL;
  }
}
